import { shallowEqual, useSelector } from 'react-redux';
import NegotiationState from '../../constants/negotiationState';
import { TradeContext, TutorialModalVariant } from '../../types/trade';
import ReducerConstants from '../../constants/reducers';

const useNegotiationTutorialVariant = (
  tradeContext: TradeContext,
  negotiationState: NegotiationState,
  sellingNetworkId: string,
  associatedTradeId: number,
  isInternalTrade: boolean
) => {
  const [sellingNetworks] = useSelector(
    state => [
      state[ReducerConstants.AUTH]?.user?.auctionSource?.sellingNetworks
    ],
    shallowEqual
  );

  const openTradeHasAssociatedTrade =
    sellingNetworks?.some(
      sn => sn.isOpenNetwork && sn.id === sellingNetworkId
    ) && associatedTradeId !== null;
  if (
    [
      NegotiationState.BUYER_COUNTER,
      NegotiationState.SELLER_COUNTER,
      NegotiationState.BUYER_FIRM
    ].includes(negotiationState)
  ) {
    return [false, null];
  }

  const tutorialMapping = {
    [TradeContext.Sell]: {
      [NegotiationState.NO_NEGOTIATION]: TutorialModalVariant.SELLER_START_NEGO,
      [NegotiationState.BUYER_OFFER]: TutorialModalVariant.SELLER_FIRST_REPLY
    },
    [TradeContext.Buy]: {
      [NegotiationState.FINAL_ASKING_PRICE]:
        TutorialModalVariant.SECOND_BIDDER_FINISH_NEGOTIATION,
      [NegotiationState.NO_NEGOTIATION]: TutorialModalVariant.BUYER_START_NEGO,
      [NegotiationState.SELLER_OFFER]: TutorialModalVariant.BUYER_FIRST_REPLY
    }
  };

  const isSellContext = tradeContext === TradeContext.Sell;
  const tutorialVariant = tutorialMapping[tradeContext][negotiationState];

  const dgnFlavour = {
    [TutorialModalVariant.SELLER_START_NEGO]:
      TutorialModalVariant.SELLER_START_NEGO_DGN,
    [TutorialModalVariant.SELLER_FIRST_REPLY]:
      TutorialModalVariant.SELLER_FIRST_REPLY_DGN
  };
  const dgnVariant =
    isSellContext && isInternalTrade && dgnFlavour[tutorialVariant];

  const openFlavour = {
    [TutorialModalVariant.SELLER_START_NEGO]:
      TutorialModalVariant.SELLER_START_NEGO_OPEN
  };
  const openVariant =
    isSellContext &&
    openTradeHasAssociatedTrade &&
    openFlavour[tutorialVariant];

  return [true, dgnVariant || openVariant || tutorialVariant];
};

export default useNegotiationTutorialVariant;
